<template>
    <section class="container columns" style="margin: 2% auto">

        <form v-on:submit.prevent="$emit('filter', { start, end, mobile_number, name ,requestNumber, deliveryCities, equipmentTypeId })" class="columns">

            <b-field :label="`${showEnd ? 'Start' : ''} Date`" class="column is-one-eighth">
                <b-datepicker
                    placeholder="Type or select a date..."
                    icon="calendar-today"
                    editable
                    @input="$emit('change', { start, end, mobile_number, name,requestNumber, deliveryCities })"
                    v-model="start">
                </b-datepicker>
            </b-field>
            <b-field label="End Date" v-if="showEnd == true" class="column is-one-eighth">
                <b-datepicker
                    placeholder="Type or select a date..."
                    icon="calendar-today"
                    editable
                    @input="$emit('change', { start, end, mobile_number, name,requestNumber, deliveryCities })"
                    v-model="end">
                </b-datepicker>
            </b-field>
            <!-- <b-field label="Mobile Number" class="column is-one-eighth">
                <b-input
                    placeholder="e.g 773454381"
                    v-model="mobile_number"/>
            </b-field> -->
            <!-- <b-field label="Farmer Name" class="column is-one-eighth">
                <b-input
                    placeholder="e.g John Dube"
                    v-model="name"/>
            </b-field> -->
            <b-field label="Request Number" class="column is-one-eighth">
                <b-input
                    placeholder="e.g XXXXX"
                    v-model="requestNumber"/>
            </b-field>
            <b-field label="Equipment Type" class="column is-one-eighth" v-if="$props.types.length > 0">
                <b-select v-model="equipmentTypeId" placeholder="Select an Equipment Type">
                    <option
                        v-for="equipmentType in $props.types"
                        :value="equipmentType.id"
                        :key="equipmentType.id">
                        {{ equipmentType.name }}
                    </option>
                </b-select>
            </b-field>
            <div class="column is-one-eighth">
                <br>
                <button class="button is-primary" type="submit" style="background-color: #05a859 ; color:#fff ;font-weight:bolder;" >Filter</button>
            </div>
        </form>
    </section>
</template>

<script>
export default {
    name: "Filters",
    data() {
        return {
          equipmentTypeId: this.filters.equipmentTypeId,
          cities: 'Harare,Kwekwe,Gweru,Bulawayo,Chegutu,Marondera,Mazvikadeyi,Mutare,Ruwa,Chitungwiza,Norton,Masvingo,Gweru City Centre, Kwekwe City Centre, Selou City Centre, Kadoma City Centre, Norton City Centre'.split(","),
          start: new Date(this.filters.fromDate),
          end: new Date(this.filters.toDate),
          mobile_number: this.filters.mobile_number,
          name: this.filters.name,
          requestNumber:this.filters.requestNumber,
          deliveryCities: this.filters.deliveryCities
        }
    },
    props: [
        'filters',
        'showEnd',
        'types'
    ],
    created() {
      console.log(this.$props.types)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Shared/Filters.vue